"use strict";

var Guarantor = function () {

  var change_combobox_options = function(comboBoxID, newOptions, resetOptions) {
    var comboBox, options;
    comboBox = $(comboBoxID);
    if (comboBox.prop) {
      options = comboBox.prop("options");
    } else {
      options = comboBox.attr("options");
    }
    if (resetOptions) {
      $("option", comboBox).remove();
    }
    $.each(newOptions, function(val, letter) {
      var letter_opt = new Option(letter["text"], letter["id"]);
      letter_opt.setAttribute("scope", letter["scope"]);
      return options[options.length] = letter_opt;
    });
    comboBox.trigger('change');
  };

  var get_guarantor_letters = function(id) {
    return $.ajax({
      type: "GET",
      url: "/assigned_letters?guarantor_id=" + id,
      dataType: "JSON",
      success: function(data) {
        console.log(data);
        return fill_letter_list(data);
      }
    });
  };

  var fill_letter_list = function(data) {
    var i, item, letter_data, lettersJson;
    letter_data = [];
    i = 0;
    while (i < data.length) {
      item = {};
      item["id"] = data[i]["id"].toString();
      item["text"] = data[i]["text"];
      item["scope"] = data[i]["scope"];
      letter_data.push(item);
      i++;
    }
    lettersJson = JSON.stringify(letter_data);
    change_combobox_options('#assigned_letter_letter_id', JSON.parse(lettersJson), true);
  };

  return {
    init: function () {
      $(document).on("change", "#guarantor_company_id", function(event) {
        get_guarantor_letters($(this).val());
        return event.preventDefault();
      });
      $(document).on("change", "#assigned_letter_letter_id", function(event) {
        var letter_selection = document.getElementById('assigned_letter_letter_id');
        $('#manifesto_guarantee_type').val(letter_selection.options[letter_selection.selectedIndex].getAttribute('scope')).trigger('change');
        return event.preventDefault();
      });
    }
  };
  
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Guarantor;
}
